import { Http } from '@/services/http'
import { ParamsClean } from '@/common/decorators/params-clean'
import { parseIsNotEmptyObj } from '@/utils/tool'
import { Injectable } from '@tanbo/vue-di-plugin'

export interface SensitiveWordsListRequestParams {
  /** 配置类型 1-文件敏感词 2-文件扫描类型 */
  config_type?: number
}

export interface SensitiveWordsListData {
  /** id */
  id: string
  /** 敏感词 */
  keywords: string[]
  /** 数据类型 1-自定义 2-财务预算 3-工资奖金 4-员工信息 5-技术方案 */
  data_type: number
  /** 描述 */
  description: string
  /** 状态 1-启用 2-禁用 */
  state: number
  // 配置类型 1-文件敏感词 2-文件扫描类型
  config_type: number
}

export interface SensitiveWordsListResponseData {
  data?: SensitiveWordsListData[]
}
export interface DelSensitiveWordsRequestParams {
  /** id */
  id?: string
}
export interface EditSensitiveWordsRequestParams {
  /** 数据类型 1-敏感词 2-扫描文件类型 */
  data_type?: number
  /** 描述 */
  description?: string
  /** id */
  id?: string
  /** 敏感词 */
  keywords?: string[]
  /** 状态 1-启用 2-禁用 */
  state?: number
  // 自定义类型
  name: string
  // 文件格式类型
  exts: string[]
  custom_exts: string[]
}
export interface GetSensitiveWordsOutgoingRecordRequestParams {
  /** 文件id */
  fileId?: string
}

export interface GetSensitiveWordsOutgoingRecordResponseDataData {
  /** 外发时间 */
  create_time: string
  /** 软件名字 */
  soft_name: string
  /** 执行进程 */
  process_name: string
  //  id
  id: string
  control_result: 1 | 2
}

export interface GetSensitiveWordsOutgoingRecordResponseData {
  data?: GetSensitiveWordsOutgoingRecordResponseDataData[]
}
export interface GetSensitiveWordsSensitiveFilesRequestParams {
  // 设备id
  device_id: string
  /** 页码 */
  page: number
  /** 每页数量 */
  limit: number
  /** 结束时间（秒） */
  end_time?: number
  /** 文件名|关键字 */
  keyword?: number
  /** 开始时间（秒） */
  start_time?: number
  //
  date?: number
}

export interface GetSensitiveWordsSensitiveFilesResponseDataRow {
  file_id: string
  /** 文件名 */
  name: string
  /** 命中敏感词 */
  keywords: string[]
  /** 文件后缀 */
  ext: string
  /** 更新时间 */
  update_time: string
  /** 记录时间 */
  create_time: string
  /** 文件路径 */
  path: string
  /** 文件大小 */
  size: number
  out_count: number
  node_id: string
  /** 触发策略 */
  strategy_name?: string
}

export interface GetSensitiveWordsSensitiveFilesResponseData {
  data?: GetSensitiveWordsSensitiveFilesResponseDataRow[]
  total?: number
}
export interface GetSensitiveWordsSensitiveFileHistoryRequestParams {
  /** 文件id */
  fileId?: string
}

export interface GetSensitiveWordsSensitiveFileHistoryResponseDataData {
  id: string
  /** 名称 */
  name: string
  /** 节点 */
  node: string
  /** 文件后缀 */
  ext: string
  /** 更新时间 */
  update_time: string
  /** 记录时间 */
  create_time: string
  /** 上一个id */
  prev_id: string
  /** 操作 */
  operation: number
  /** 文件id */
  file_id: string
  /** top */
  top: number
  // 外发次数
  send_times: number
}

export interface GetSensitiveWordsSensitiveFileHistoryResponseData {
  data?: GetSensitiveWordsSensitiveFileHistoryResponseDataData[]
}
export interface GetSensitiveWordsSensitiveFileInfoRequestParams {
  /** 文件id */
  fileId?: string
}

export interface GetSensitiveWordsSensitiveFileInfoResponseDataData {
  file_id: string
  /** 文件名 */
  name: string
  /** 命中敏感词 */
  keywords: string[]
  /** 文件后缀 */
  ext: string
  /** 更新时间 */
  update_time: string
  /** 记录时间 */
  create_time: string
  /** 文件路径 */
  path: string
  /** 文件大小 */
  size: string
  computer_name: string
  user_name: string
  system_ip: string
  user_mark:string
  client_ip: string
  group_name: string
}

export interface GetSensitiveWordsSensitiveFileInfoResponseData {
  data?: GetSensitiveWordsSensitiveFileInfoResponseDataData
}
export interface GetSensitiveWordsResultsRequestParams {
  /** 页码 */
  page: number
  /** 每页数量 */
  limit: number
  /** 关键字 */
  keyword?: string
  terminal_keyword?: string
  group_id?: number | string
  system_types: number[]
  start_time:string
  end_time:string
}

export interface GetSensitiveWordsResultsRequestParamsDataRow {
  /** 终端设备id */
  device_id: string
  /** 分组id */
  group_id: number
  /** 计算机名 */
  computer_name: string
  /** 内网ip,以"，"分隔 */
  system_ip: string
  /** 登记用户名 */
  user_mark: string
  /** Mac地址 */
  mac: string
  /** 操作系统 */
  system_name: string
  /** 终端登录状态,1-在线，2-离线 */
  login_status: number
  /** 外网ip */
  client_ip: string
  /** 分组名 */
  group_name: string
  /** 系统类型,0-全部，1-windows,2-linux，3-windows server，4-mac */
  system_type: number
  /** 命中敏感词文件数量 */
  service_count?: number
  // 是否授权
  auth_status?: {
    permission_name: string
    auth_status: number
  }[]
  //
  $selected: boolean
  area_type: number
}

export interface GetSensitiveWordsResultsResponseData {
  data?: GetSensitiveWordsResultsRequestParamsDataRow[]
  total?: number
}
export interface SensitiveWordsScanRequestParams {
  /** 文件id */
  device_ids?: string[]
  select_type: 0 | 1
  group_id: string
}
export interface PostSensitiveWordsModifiedStateRequestParams {
  /** id */
  id: string
  /** 状态 1-启用 2-禁用 */
  state: number
}
export interface SensitiveWordsFileOutgoingRequestParams {
  /** 页码 */
  page: number
  /** 每页数量 */
  limit: number
  /** 审批状态, 2-同意，3-拒绝,4-已失效 0-全部(2,3,4) */
  apply_state?: number
  /** 结束时间（秒） */
  end_time?: string
  keyword?: string
  /** 开始时间（秒） */
  start_time?: string
  //
  date: number[]
  /** 策略id */
  strategy_id?: string
}

export interface SensitiveWordsFileOutgoingResponse {
  id: string
  file_id: string
  /** 申请时间 */
  apply_time: string
  /** 登记用户名 */
  user_mark: string
  /** 分组名称 */
  group_name: string
  /** 关键字 */
  keyword: string[]
  /** 终端设备id */
  device_id: string
  /** 外发方式 */
  soft_name: string
  /** 执行路径 */
  process_path: string
  /** 执行路径 */
  process_name: string
  /** 内网IP地址 */
  client_ip: string
  /** 外网IP地址 */
  system_ip: string
  /** 文件大小 */
  size: number
  /** 文件名 */
  file_name: string
  /** 文件类型 */
  ext: string
  /** 源路径 */
  file_path: string
  /** 电脑名 */
  computer_name: string
  /** 审批状态, 2-同意，3-拒绝,4-已失效 */
  apply_state: number
  /** 原因 */
  reason: string
  /** 系统类型 */
  system_type: number
  login_status: number
  way: string
  /** 触发策略 */
  strategy_name?: string
}

export interface SensitiveWordsFileOutgoingResponseData {
  data?: SensitiveWordsFileOutgoingResponse[]
  total?: number
}
export interface SensitiveWordsFileOutgoingApproveRequestParams {
  /** 记录id */
  record_id: number
  /** 是否同意 true-同意 false-拒绝 */
  is_agree: boolean
  /** 理由 */
  reason: string
}

export interface SensitiveFileSendSendFileRecordRequestParams {
  /** 页码 */
  page: number
  /** 每页数量 */
  limit: number
  /** 结束时间 */
  end_time?: number
  /** 分组id */
  group_id?: string
  /** 关键字 */
  keyword?: string
  /** 开始时间 */
  start_time?: number
  //1已放行2已拦截
  control_result: 1 | 2
  date: string[]
  /** 策略id */
  strategy_id?: string
  /** 前端字段 */
  dateRange?: any[]
}

export interface SensitiveFileSendSendFileRecordRow {
  /** 终端设备id */
  device_id: string
  /** 计算机名 */
  computer_name: string
  /** 内网ip,以"，"分隔 */
  system_ip: string
  /** 登记用户名 */
  user_mark: string
  /** Mac地址 */
  mac: string
  /** 操作系统 */
  system_name: string
  /** 外网ip */
  client_ip: string
  /** 分组名 */
  group_name: string
  /** 命中敏感词文件数量 */
  file_name?: string
  /** 命中敏感词文件数量 */
  file_path?: string
  // 文件id
  file_id: string
  /** 文件大小 */
  file_size?: number
  /** 命中敏感词 */
  keywords?: string[]
  /** 进程路径 */
  process_path?: string
  /** 外发方式 */
  soft_name?: string
  node_id?: string
}

export interface SensitiveFileSendSendFileRecordRowResponseData {
  data?: SensitiveFileSendSendFileRecordRow[]
  total?: number
}
export interface SensitiveWordsFileExtData {
  /** 1-办公类 2-压缩类型 3-视频类 4-图片类型 5-建模类型 */
  type: number
  data: string[]
}

export interface SensitiveWordsFileExt {
  data?: SensitiveWordsFileExtData[]
}
export interface SensitiveWordsChannelData {
  /** 1-网络协议 2-通信软件 3-网盘 4-传播设备 */
  type: number
  data: string[]
}

export interface SensitiveWordsChannel {
  data?: SensitiveWordsChannelData[]
}
export interface SensitiveWordsFileOutgoingLogRequestParams {
  /** 页码 */
  page: number
  /** 每页数量 */
  limit: number
  /** 结束时间 */
  end_time?: string
  /** 分组id */
  group_id?: string
  /** 关键字 */
  keyword?: string
  /** 开始时间 */
  start_time?: string
}

export interface SensitiveWordsFileOutgoingLogRow {
  /** 记录 id（列表行键等） */
  id?: string
  /** 终端设备id */
  device_id: string
  /** 计算机名 */
  computer_name: string
  /** 内网ip,以"，"分隔 */
  system_ip: string
  /** 登记用户名 */
  user_mark: string
  /** Mac地址 */
  mac: string
  /** 外网ip */
  client_ip: string
  /** 分组名 */
  group_name: string
  /** 操作时间 */
  apply_time?: string
  /** 文件id */
  file_id?: string
  /** 命中敏感词文件数量 */
  file_name?: string
  /** 命中敏感词文件数量 */
  file_path?: string
  /** 文件大小 */
  file_size?: number
  /** 命中敏感词 */
  keywords?: string[]
  /** 进程路径 */
  process_path?: string
  // 进程名称
  process_name?: string
  /** 外发方式 */
  soft_name?: string
  /** 触发策略 */
  strategy_name?: string
  /** 1 已放行 2 已阻断 */
  control_result?: 1 | 2
}

export interface SensitiveWordsFileOutgoingLogResponseData {
  data?: SensitiveWordsFileOutgoingLogRow[]
  total?: number
}
export interface ResponseDataSensitiveWordsFileView {
  /** 页码 */
  page: number
  /** 每页数量 */
  limit: number
  /** 结束时间 */
  end_time?: string
  /** 文件名 */
  file_name?: string
  /** group id */
  group_id?: string
  /** 关键字集合 */
  keywords?: string[]
  /** 开始时间 */
  start_time?: string
  /** 终端关键字 */
  terminal_keyword?: string
  keyword: string
  system_types: number[]
}

export interface RequestParamsSensitiveWordsFileViewData {
  /** 内网ip,以"，"分隔 */
  system_ip: string
  /** 登记用户名 */
  user_mark: string
  /** 外网ip */
  client_ip: string
  /** 分组名 */
  group_name: string
  /** 外发次数 */
  out_count: string
  /** 计算机名 */
  computer_name?: string
  id?: string
  /** 命中敏感词 */
  keywords?: string[]
  /** 文件名 */
  name?: string
  /** 节点id */
  node_id?: string
  /** 文件路径 */
  path?: string
  /** 文件大小 */
  size?: number
  /** 更新时间 */
  update_time?: string
  /** 用户名 */
  user_name?: string
}

export interface RequestParamsSensitiveWordsFileView {
  data?: RequestParamsSensitiveWordsFileViewData[]
  total?: number
}
export interface SensitiveWordsFileListRequestParams {
  /** 关键字集合 */
  keywords?: string[]
}

export interface SensitiveWordsFileListResponseData {
  /** 涉及文件数 */
  file_count?: number
  /** 关键字 */
  keyword?: string
  /** 分布终端数 */
  terminal_count?: number
  name?: string
}
export interface SensitiveWordsFileViewCountData {
  /** 涉及的全部文件数 */
  total_file_count?: number
  /** 涉及的全部终端数量 */
  total_terminal_count?: number
}export interface statisticsResponseData {
  /** 今日外发文件数 */
  today_send_count: number
  /** 今日阻断外发数 */
  today_block_count: number
}
export interface CountTopRequestParams {
  /** 时间范围，默认近24小时 */
  start_time: string
  /** 时间范围，默认近24小时 */
  end_time: string
  /** top数量 */
  limit: number
}

export interface CountTopData {
  /** 名称 (敏感词类型名称，如 "财务预算") */
  name: string
  /** 外发次数 */
  send_count: number
}

export interface CountTopResponseData {
  data: CountTopData[]
}
export interface statsResponseData {
  /** 策略总数 */
  strategy_total_count: number
  /** 显性策略数量（mark_type=2） */
  explicit_strategy_count: number
  /** 隐形策略数量（mark_type=1） */
  implicit_strategy_count: number
  /** 自定义策略数量（mark_type=3） */
  custom_strategy_count: number
  /** 覆盖分组数量（去重） */
  covered_group_count: number
}
export interface TerminalTopRequestParams {
  /** 数量 */
  limit: number
  /** 结束时间 */
  end_time?: string
  /** 开始时间 */
  start_time?: string
}

export interface AuthStatus {
  /** 权益key名 */
  permission_name: string
  /** 授权状态：0-正常，1-待授权 2-未订阅 */
  auth_status: number
}

export interface TerminalTopData {
  /** 终端设备id */
  device_id: string
  /** 分组id */
  group_id: string
  /** 计算机名 */
  computer_name: string
  /** 内网ip,以"，"分隔 */
  system_ip: string
  /** 登记用户名 */
  user_mark: string
  /** Mac地址 */
  mac: string
  /** 操作系统 */
  system_name: string
  /** 终端登录状态,1-在线，2-离线 */
  login_status: number
  /** 外网ip */
  client_ip: string
  /** 分组名 */
  group_name: string
  /** 系统类型,0-全部，1-windows,2-linux，3-windows server，4-mac */
  system_type: number
  /** 授权状态：0-正常，1-待授权 2-未订阅 */
  auth_status?: AuthStatus[]
  /** 命中敏感词 */
  keywords?: string[]
  /** 扫描状态 1-扫描中 2-扫描完成 3-扫描失败 */
  scan_state?: number
  /** 命中敏感词文件数量 */
  service_count?: number
  outgoing_count?: number
}

export interface TerminalTopResponseData {
  data?: TerminalTopData[]
}
export interface SensitiveWordsStatResponseData {
  /** 生效敏感词数量(所有启用配置中的敏感词总数) */
  keyword_count?: string
}
@Injectable()
export class SensitiveService {
  constructor(private http: Http) {
  }
  // 外发记录
  getSensitiveWordsOutgoingRecord(node_id: string, all_record?: number) {
    return this.http.post<GetSensitiveWordsOutgoingRecordResponseData>('/sensitivefilesend/outgoing_record', { node_id, all_record: all_record ?? 0 })
  }
  // 命中敏感词列表
  @ParamsClean()
  getSensitiveWordsSensitiveFiles(data: GetSensitiveWordsSensitiveFilesRequestParams) {
    return this.http.post<GetSensitiveWordsSensitiveFilesResponseData>('/sensitivewords/sensitive_files', data)
  }
  // 敏感词列表
  getSensitiveWordsList(data: SensitiveWordsListRequestParams) {
    return this.http.post<SensitiveWordsListResponseData>('/sensitivewords/list', data)
  }
  // 修改/新增
  postSensitiveWords(data: EditSensitiveWordsRequestParams) {
    return this.http.post(data.id ? '/sensitivewords/update' : '/sensitivewords/add', data)
  }
  // 删除
  delSensitiveWords(data: DelSensitiveWordsRequestParams) {
    return this.http.post('/sensitivewords/delete', data)
  }
  // 文件信息历史记录
  getSensitiveWordsSensitiveFileHistory(id: string, top?: number) {
    return this.http.post<GetSensitiveWordsSensitiveFileHistoryResponseData>('/sensitivewords/sensitive_file_history', { id, top })
  }
  // 文件信息查询
  getSensitiveWordsSensitiveFileInfo(node_id: string) {
    return this.http.post<GetSensitiveWordsSensitiveFileInfoResponseData>('/sensitivewords/sensitive_file_info', { node_id })
  }
  // 敏感文件扫描列表
  @ParamsClean()
  getSensitiveWordsResults(data: GetSensitiveWordsResultsRequestParams) {
    return this.http.post<GetSensitiveWordsResultsResponseData>('/sensitivewords/results', data)
  }
  // 扫描上报
  getSensitiveWordsScan(params: SensitiveWordsScanRequestParams) {
    return this.http.post('/sensitivewords/scan', params)
  }
  // 启用禁用
  postSensitiveWordsModifiedState(data: PostSensitiveWordsModifiedStateRequestParams) {
    return this.http.post('/sensitivewords/modified_state', data)
  }
  // 触发文件外发管控记录
  @ParamsClean()
  getSensitiveWordsFileOutgoing(data: SensitiveWordsFileOutgoingRequestParams) {
    const parseData = parseIsNotEmptyObj(data)
    return this.http.post<SensitiveWordsFileOutgoingResponseData>('/sensitivefilesend/approve_list', parseData)
  }
  // 审批文件外发
  getSensitiveWordsFileOutgoingApprove(data: SensitiveWordsFileOutgoingApproveRequestParams) {
    return this.http.post('/sensitivefilesend/approve', data)
  }
  // 敏感日志
  @ParamsClean()
  getSensitiveWordsFileOutgoingLog(data: Partial<SensitiveFileSendSendFileRecordRequestParams>) {
    data = parseIsNotEmptyObj(data)
    return this.http.post<SensitiveWordsFileOutgoingLogResponseData>('/sensitivefilesend/send_file_record', data)
  }
  // 敏感日志导出
  @ParamsClean([0], 1)
  getSensitiveFileSendExport(type: 0 | 1 = 0, data: Partial<SensitiveWordsFileOutgoingLogRequestParams>, moduleName: string) {
    data = parseIsNotEmptyObj(data)
    const params = Object.assign({}, data, {
      file_type: type,
      page: 1, // 不分页
      limit: 9999999
    })
    return this.http.downloadWithBlob('/sensitivefilesend/export', params, moduleName)
  }
  // 文件拓展名
  getSensitiveWordsFileExt() {
    return this.http.post<SensitiveWordsFileExt>('/sensitivewords/file_ext', {})
  }
  // 外发通道
  getSensitiveWordsChannel() {
    return this.http.post<SensitiveWordsChannel>('/sensitivewords/channel', {})
  }
  // 敏感文件文件视图
  @ParamsClean()
  getSensitiveWordsFileView(data: RequestParamsSensitiveWordsFileView) {
    return this.http.post<ResponseDataSensitiveWordsFileView>('/sensitivewords/file_view', data)
  }
  // 敏感文件关键字列表
  getSensitiveWordsFileList(data: SensitiveWordsFileListRequestParams) {
    return this.http.post<SensitiveWordsFileListResponseData>('/sensitivewords/file_list', data)
  }
  // 敏感文件文件视图-终端数量
  getSensitiveWordsFileViewCount (data: ResponseDataSensitiveWordsFileView) {
    return this.http.post<SensitiveWordsFileViewCountData>('/sensitivewords/file_view_count', data)
  }
  getSensitivefilesendStatistics () {
    return this.http.post<statisticsResponseData>('/sensitivefilesend/statistics', {})
  }
  getSensitivefilesendKeywordTypeCountTop (data: CountTopRequestParams) {
    return this.http.post<CountTopResponseData>('/sensitivefilesend/keyword_type_count_top', data)
  }
  getSensitivewordsTerminalTop (data: TerminalTopRequestParams) {
    return this.http.post<TerminalTopResponseData>('/sensitivefilesend/terminal_outgoing_top', data)
  }
  getSensitivewordsStat () {
    return this.http.post<SensitiveWordsStatResponseData>('/sensitivewords/stat', {})
  }
}
